import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { UploadFileService } from '@app/shared/services/upload-file.service';
import { BlobFileApiModel } from '@app/api/api-models';
import { AttachmentApiModel } from '@app/api/api-models/attachments';
import { HttpClientService } from '@app/api/api-services/http-client.service';

@Injectable()
export class AttachmentsService {
  public apiUrl = 'attachments';

  constructor(private readonly http: HttpClientService, private readonly uploadFileService: UploadFileService) {}

  public attachToAssignmentCompletion(file: File, id: number): Observable<AttachmentApiModel> {
    const payload = new FormData();
    this.uploadFileService.append(payload, file);

    return this.http.post<AttachmentApiModel>(`${this.apiUrl}?assignmentCompletionId=${id}`, payload);
  }

  public attachToIncident(file: File, id: number): Observable<AttachmentApiModel> {
    const payload = new FormData();
    this.uploadFileService.append(payload, file);

    return this.http.post<AttachmentApiModel>(`${this.apiUrl}/incident-file/${id}`, payload);
  }

  public download(formInstanceId: number, id: string, path = ''): Observable<BlobFileApiModel> {
    return this.http
      .get<BlobFileApiModel>(`${this.apiUrl}/${path}${id}/${formInstanceId}`)
      .pipe(map((x) => new BlobFileApiModel().deserialize(x)));
  }
}
